<template>
  <div
    class="toggle-wrapper"
    :class="{ active: isActive }"
    @click="toggle"
  >
    <div class="toggle-dot"></div>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
    }
  }
}
</script>

<style scoped>
    .toggle-wrapper {
    min-width: 50px;
    height: 24px;
    border-radius: 9999px;
    background-color: #ccc;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s ease;
    }
    .toggle-wrapper.active {
    background-color: #FBBC05;
    }
    .toggle-dot {
    width: 20px;
    height: 20px;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    top: 2px;
    left: 2px;
    transition: left 0.3s ease;
    }
    .toggle-wrapper.active .toggle-dot {
    left: 26px;
    }
</style>
